/** Matches API incident status enums (query + PATCH body uses lowercase). */
export const INCIDENT_STATUS_VALUES = ["pending", "reviewed", "resolved"];

/** Pass to list API ?status=pending,reviewed,resolved */
export const INCIDENT_STATUSES_ALL = INCIDENT_STATUS_VALUES.join(",");

const LABEL_MAP = {
  pending: "Pending",
  reviewed: "Reviewed",
  resolved: "Resolved",
};

export function formatIncidentStatusLabel(value) {
  if (!value || typeof value !== "string") return "—";
  const v = value.toLowerCase().trim();
  return LABEL_MAP[v] ?? v.charAt(0).toUpperCase() + v.slice(1);
}

/** Badge styles for Tailwind */
export function getIncidentStatusBadgeClass(status) {
  const v = (status || "").toLowerCase().trim();
  if (v === "pending") return "bg-amber-100 text-amber-800";
  if (v === "reviewed") return "bg-sky-100 text-sky-800";
  if (v === "resolved") return "bg-emerald-100 text-emerald-800";
  return "bg-slate-200 text-slate-700";
}
